module.exports = __webpack_public_path__ + "static/img/wdtb_one.39156b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wdtb_one.png
// module id = LDgM
// module chunks = 1